import React from "react"
import { Helmet } from "react-helmet"

export default function Index() {
  return (
    <>
      <Helmet>
        <title>Chaldeaprjkt</title>
      </Helmet>
      <div className="h-screen flex items-center justify-center bg-teal-500">
        <div>
          <div className="text-center p-5">
            <span className="text-7xl font-bold text-white tracking-tight italic">
              comingsoon!
            </span>
          </div>
          <div className="text-center p-5">
            <span className="text-white">2021 &copy; chaldeaprjkt</span>
          </div>
        </div>
      </div>
    </>
  )
}
